import { useRootStackNavigation } from '$tablet-app/src/app/navigation/hooks';
import { Button } from '@akin-home/buttons/native';
import { colors, spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { useMemo } from 'react';
import { FlatList, StyleSheet, Text, View } from 'react-native';
import { useRobotStateStore } from '../../stores/useRobotStateStore';
import { RobotDevice } from '../../types';
import { compareRobotConnStatus } from '../../utils';
import { KnownRobotCard } from './KnownRobotCard';

interface KnownRobotsBarProps {
  onSelectRobot?: (robot: RobotDevice) => any;
}

export const KnownRobotsBar = (props: KnownRobotsBarProps) => {
  const robotDevices = useRobotStateStore((state) => state.robotDevices);

  const knownRobots = useMemo<RobotDevice[]>(() => {
    const availableRobots = Object.values(robotDevices);

    availableRobots.sort((robotA, robotB) =>
      compareRobotConnStatus(
        robotA.websocketConnection?.connectionStatus,
        robotB.websocketConnection?.connectionStatus,
        true
      )
    );
    return availableRobots;
  }, [robotDevices]);

  const { navigate } = useRootStackNavigation();

  return (
    <View style={styles.container}>
      <FlatList
        style={styles.flatlist}
        contentContainerStyle={styles.flatlistInnerContainer}
        horizontal
        data={knownRobots}
        renderItem={({ item }) => (
          <KnownRobotCard
            key={'knownRobotCard_' + item.id}
            robot={item}
            onPress={() => props.onSelectRobot?.(item)}
            width={250}
            height={100}
          />
        )}
        ItemSeparatorComponent={SeparatorComponent}
        ListFooterComponent={FooterComponent}
        ListEmptyComponent={EmptyComponent}
      />

      {/* Add New Robot Button */}
      <View style={styles.buttonContainer}>
        <Button
          variant="primary"
          icon="plus"
          style={styles.button}
          iconSize={styles.button.width * 0.8}
          onPress={() => {
            navigate('RobotConnect');
          }}
        >
          {/* {`Scan For Nearby Robots`} */}
        </Button>
      </View>
    </View>
  );
};

const EmptyComponent = () => {
  return (
    <View style={flatlistComponentStyles.emptyContainer}>
      <FontAwesomeIcon
        icon={'robot'}
        size={30}
        style={flatlistComponentStyles.emptyIcon}
      />
      <Text style={flatlistComponentStyles.emptyText}>
        No robots found, click + to add a new one
      </Text>
    </View>
  );
};

const SeparatorComponent = () => {
  return <View style={flatlistComponentStyles.separatorContainer} />;
};

const FooterComponent = () => {
  return <View style={flatlistComponentStyles.footerContainer} />;
};

export const styles = StyleSheet.create({
  container: {
    height: '100%',
    flex: 1,
    flexDirection: 'row',
    borderRadius: 10,
    overflow: 'hidden',

    backgroundColor: 'white',
    elevation: 3,
  },
  flatlist: {
    paddingHorizontal: spacing[3],
    height: '100%',
    width: '100%',
  },
  flatlistInnerContainer: {
    flexDirection: 'row',
    flexGrow: 1,
  },
  buttonContainer: {
    backgroundColor: 'white',
    borderColor: colors.neutral[60],
    borderLeftWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    height: '100%',
    padding: spacing[2],
  },
  button: {
    width: 50,
    borderRadius: 50 / 2,
    aspectRatio: 1,
  },
});

export const flatlistComponentStyles = StyleSheet.create({
  emptyContainer: {
    flex: 1,
    height: 100,
    marginVertical: spacing[2],

    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  emptyIcon: {
    height: '100%',
    width: '100%',
  },
  emptyText: {
    marginHorizontal: spacing[2],
    textAlign: 'center',
    textAlignVertical: 'center',
    fontSize: 22,
  },
  separatorContainer: {
    width: styles.flatlist.paddingHorizontal,
  },
  footerContainer: {
    width: styles.button.width + styles.buttonContainer.padding * 2,
    marginHorizontal: styles.flatlist.paddingHorizontal,
  },
});
